import { useEffect, useRef, useState } from "react";
import { Modal, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import _ from "lodash";
import {
  ACCEPTED_IMAGE_TYPES,
  rejectInvalidImage,
  updateBrickCollection,
  uploadImage,
} from "../../utils";
import useOrganization from "../../hooks/useOrganization";

interface Props {
  brickCollection: any | null;
  open: boolean;
  onClose(): void;
}

const UploadBricksModal: React.FC<Props> = ({
  brickCollection,
  open,
  onClose,
}) => {
  const organization = useOrganization();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [fileList, setFileList] = useState<any[]>([]);
  const keys = useRef<Record<string, string>>({});

  useEffect(() => {
    setSubmitting(false);
  }, [open]);

  const handleFileChanged = ({ fileList }: { fileList: any[] }) => {
    setFileList(fileList);
  };

  const handleUpload = async ({
    onSuccess,
    onError,
    onProgress,
    file,
  }: any) => {
    try {
      keys.current[file.uid] = await uploadImage(
        organization,
        brickCollection._id,
        "brick",
        file,
        (percent) => onProgress({ percent }, file)
      );
      onSuccess(null, file);
    } catch (e) {
      onError(e, null, file);
    }
  };

  const submitBricks = async () => {
    setSubmitting(true);
    await updateBrickCollection(organization, brickCollection._id, {
      bricks: [
        ...brickCollection.bricks,
        ...fileList.map((file) => ({
          type: "full",
          image: keys.current[file.uid],
        })),
      ],
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={submitBricks}
      okButtonProps={{
        disabled: submitting || !_.every(fileList, (f) => f.status === "done"),
      }}
      okText="Klaar"
      closable={false}
      destroyOnHidden
    >
      <Upload.Dragger
        accept={ACCEPTED_IMAGE_TYPES}
        beforeUpload={rejectInvalidImage}
        listType="picture-card"
        multiple
        showUploadList={{
          showDownloadIcon: false,
          showPreviewIcon: true,
          showRemoveIcon: true,
        }}
        customRequest={(e) => handleUpload(e)}
        onChange={(e) => handleFileChanged(e)}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Klik of sleep een bestand hier om te uploaden
        </p>
      </Upload.Dragger>
    </Modal>
  );
};

export default UploadBricksModal;
